<!-- <div class="form-group {{ (fieldValid == -1 || fieldValid == 1) ? '' : 'has-error' }}"> -->
  <div class="form-group">
    <label>
      {{ name }} <sup *ngIf="required">*</sup>
      <i class="ti-reload fa fa-spin" *ngIf="loading"></i>
    </label>

    <mat-select class="form-control border-input" [(ngModel)]="value" (valueChange)="valueChanged($event); validate()">
      <mat-select-trigger>
          <div class="">{{ (value != null && value != '' || +value >= 0) ? (isObject ? value[objectNameField] : options[value]) : 'Choose an item' }}</div>
      </mat-select-trigger>
      <mat-option *ngIf="!noEmptyValue" [value]="isObject ? null : -1">Choose an item</mat-option>

      <ng-template ngFor let-item let-i="index" [ngForOf]="options">
        <mat-option *ngIf="(skipBlankItems && item != null && item.length) || !skipBlankItems" [value]="isObject ? item : i">{{ isObject ? item[objectNameField] : item }}</mat-option>
      </ng-template>
    </mat-select>

    <span class="help-block animated fadeIn">
        <strong class="text-default" [class.text-danger]="required && fieldValid != 1">
          <small *ngIf="required && fieldValid != 1; else showHelpText">Select an item for {{ name }}</small>
          <ng-template #showHelpText>
            <small>{{ helpText }}</small>
          </ng-template>
        </strong>
    </span>
    <!-- <span class="help-block animated fadeIn" [class.invisible]="!helpText || !helpText.length || fieldValid == -1 || fieldValid == 1">
        <strong class="text-danger"><small>Select an item for {{ name }}.</small></strong>
    </span> -->
</div>
